export const SNIPPETS = {
  CALCULATOR: "Calculator",
  WHERE_TO_BUY_HEADER: "where-to-buy-header",
  WHERE_TO_BUY_FOOTER: "where-to-buy-footer",
  WHERE_TO_BUY_IN_PAGE: "where-to-buy-in-page",
  WHERE_TO_BUY_HEADER_PB: "where-to-buy-header-polebase",
  WHERE_TO_BUY_FOOTER_PB: "where-to-buy-footer-polebase",
  WHERE_TO_BUY_HEADER_RH: "where-to-buy-header-rosetta-hardscapes",
  WHERE_TO_BUY_FOOTER_RH: "where-to-buy-footer-rosetta-hardscapes",
  WHERE_TO_BUY_HEADER_RR: "where-to-buy-header-redi-rock",
  WHERE_TO_BUY_FOOTER_RR: "where-to-buy-footer-redi-rock",
  COLOR_OPTIONS_LOOKUP: "color-options-lookup",
  PRELIMINARY_HEIGHT_GUIDE: "preliminary-height-guide",
  STAFF_DIRECTORY: "staff-directory"
};
